import { render, staticRenderFns } from "./bbs.vue?vue&type=template&id=2eb30b78&scoped=true&"
import script from "./bbs.vue?vue&type=script&lang=js&"
export * from "./bbs.vue?vue&type=script&lang=js&"
import style0 from "./bbs.vue?vue&type=style&index=0&id=2eb30b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb30b78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb30b78')) {
      api.createRecord('2eb30b78', component.options)
    } else {
      api.reload('2eb30b78', component.options)
    }
    module.hot.accept("./bbs.vue?vue&type=template&id=2eb30b78&scoped=true&", function () {
      api.rerender('2eb30b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/bbs.vue"
export default component.exports